// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_nav":"main_nav-px0aEdfs","box":"box-YK7u4rFq","ad":"ad-1Ct0jEGI","search":"search-Arae6oy2","logo":"logo-1eVvRzEa","userinfo":"userinfo-1AvsZy1d"};